import { useEffect } from 'react'

/**
 * Adds .home__reveal--visible when [data-reveal] enters the viewport.
 * Respects prefers-reduced-motion (all sections visible immediately).
 */
export function useReveal() {
  useEffect(() => {
    const nodes = document.querySelectorAll('[data-reveal]')
    if (!nodes.length) return

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    if (reduceMotion) {
      nodes.forEach((n) => n.classList.add('home__reveal--visible'))
      return
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('home__reveal--visible')
          }
        })
      },
      { threshold: 0.06, rootMargin: '0px 0px -32px 0px' }
    )

    nodes.forEach((n) => io.observe(n))
    return () => io.disconnect()
  }, [])
}
